import * as types from "./types";

import {getIncomeListAxios, postIncomeListAxios, updateIncomeListAxios, deleteIncomeListAxios} from  "./services";

export async function getIncomeListAction({ commit }, id) {
    commit(types.LOADING_ITEM, true);
    try {
        const { data } = await getIncomeListAxios(id);
        commit(types.GET_INCOME_LIST, data.result);
        return data.result;
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_ITEM, false);
    }
}

export async function postIncomeAction({ commit }, payload) {
    commit(types.LOADING_ITEM, true);
    try {
        const { data } = await postIncomeListAxios(payload);
        commit(types.POST_INCOME, data.result);
        return data;
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_ITEM, false);
    }
}

export async function updateIncomeAction({ commit }, payload) {
    commit(types.LOADING_ITEM, true);
    try {
        const { data } = await updateIncomeListAxios(payload);
        commit(types.UPDATE_INCOME, data.result);
        return data;
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_ITEM, false);
    }
}

export async function deleteIncomeAction({ commit }, id) {
    commit(types.LOADING_ITEM, true);
    try {
        const { data } = await deleteIncomeListAxios(id);
        commit(types.DELETE_INCOME, data.result);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_ITEM, false);
    }
}